/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".module-bg[_ngcontent-%COMP%]{background-image:url(/assets/media/nds/circuit.jpg);background-attachment:fixed;background-size:cover}.module-approval-bg[_ngcontent-%COMP%]{background-color:#ff9d00;background-image:url(/assets/media/nds/approval-bg.svg);background-attachment:fixed;background-size:cover}"];
export { styles as styles };
